import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const TelefonoSelect = ({ value, onChange, className = "" }) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label-telefono">
        Número de Teléfono
      </InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-telefono"
        id="demo-simple-select-telefono"
        value={value}
        label="Número de Teléfono"
        onChange={(event) => onChange(event.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value={"C"}>Consolidado</MenuItem>
        <MenuItem value={"R"}>Registrado</MenuItem>
        <MenuItem value={"N"}>No Registrado</MenuItem>
      </Select>
    </FormControl>
  );
};

export default TelefonoSelect;
